import { ButtonHTMLAttributes, CSSProperties, FC } from 'react'
import { Button as _Button, ButtonTypeMap } from '@mui/material'
import authorization from '../../helpers/authorization'
import { AuthorizationType } from '../../types/authorization-types'
import { Spinner } from './Spinner'

interface ExtraProps {
  loading?: boolean
  onClick?: (...args: any[]) => any
  style?: CSSProperties
  type?: ButtonHTMLAttributes<any>['type']
  className?: string
  id?: string
  permissions?: number[]
}

export type MainButtonProps = ButtonTypeMap<ExtraProps>['props']

export const MainButton: FC<MainButtonProps> = ({
  type = 'button',
  children,
  size,
  color = 'primary',
  variant = 'contained',
  onClick,
  href,
  disabled = false,
  loading,
  startIcon,
  endIcon,
  style,
  permissions,
  id,
  ...rest
}) => {
  const Button = permissions ? authorization(_Button, permissions, AuthorizationType.Disabled) : _Button

  return (
    <Button
      id={id}
      startIcon={startIcon}
      href={href}
      endIcon={loading ? <Spinner color="inherit" size={24} /> : endIcon}
      size={size}
      style={style}
      type={type}
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {children}
    </Button>
  )
}
